export const CONSENT_DESCRIPTION = Object.freeze({
  ENROLLED: "Auto Responder is set to automatically reply to the lead.",
  PAUSED: "Auto Responder will send a message in a few minutes.",
  DISENROLLED: "Auto Responder is set to pause automatic replies to the lead.",
});

export const CONSENT_STATUS = Object.freeze({
  ENROLLED: "ENROLLED",
  PAUSED: "PAUSED",
  DISENROLLED: "DISENROLLED",
});
